import { MidiDevice, MidiDeviceState } from "../model/MidiDevice.js";
import { Polygon } from "./Polygon.js";

export interface MidiDeviceStateViewOptions {
    midi: MidiDevice;
    container: HTMLElement;
}

export class MidiDeviceStateView {

    private _element: HTMLDivElement;
    private _options: MidiDeviceStateViewOptions;

    constructor(options: MidiDeviceStateViewOptions) {

        options = e5.object.merge({
        } as MidiDeviceStateViewOptions, options);
        this._options = options;

        this._element = document.createElement("div");
        this._element.className = "midi-device-state-view";
        this._element.innerHTML = `
            <div class="midi-device-state-view__content">
                <div class="midi-device-state-view__icon"></div>
                <div class="midi-device-state-view__message"></div>
            </div>`;

        new Polygon({
            color: "var(--color__red--1)",
            shape: "13",
            container: this._element.querySelector(".midi-device-state-view__content"),
            prepend: true,
            shadow: true,
            gradient: false
        });

        this.updateState(options.midi.state);
        options.midi.onStateChange.add((state) => this.updateState(state));

        // this.updateState("disconnected");
        // this.updateState("connected");
        // this.updateState("error");

        options.container.appendChild(this._element);
    }

    private updateState(state: MidiDeviceState): void {

        this._element.setAttribute("data-state", state);

        if (state === "disconnected") {
            this.setIcon("ms-outlined ms-cable");
            this.setMessage("Bitte verbinden Sie das Mischpult über USB mit dem Computer.");
        }
        else if (state === "connected") {
            this.setIcon("ms-outlined ms-discover_tune");
            this.setMessage("Ermittle Stellungen der Schiebregler.");
        } else if (state === "ready") {

        } else if (state === "error") {
            this.setIcon("ms-outlined ms-report");
            this.setMessage("Leider ist ein Fehler mit dem Mischpult aufgetreten. Bitte starten Sie die Anwendung erneut.");
        }
    }

    private setIcon(icon: string): void {
        const i = this._element.querySelector(".midi-device-state-view__icon")
        i.className = "midi-device-state-view__icon " + icon;
    }

    private setMessage(message: string): void {
        const i = this._element.querySelector(".midi-device-state-view__message")
        i.textContent = message;
    }
}